"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LodestarGlobalStyles = void 0;
var _react = _interopRequireDefault(require("react"));
var _focusMode = require("../components/focusMode");
var _MotionResetStyles = require("./MotionResetStyles");
var _ScrollbarStyles = require("./ScrollbarStyles");
const LodestarGlobalStyles = () => {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_focusMode.FocusToggleStyles, null), /*#__PURE__*/_react.default.createElement(_MotionResetStyles.MotionResetStyles, null), /*#__PURE__*/_react.default.createElement(_ScrollbarStyles.ScrollbarStyles, null));
};
exports.LodestarGlobalStyles = LodestarGlobalStyles;
//# sourceMappingURL=LodestarGlobalStyles.js.map